export const sortByParams = [
  { label: 'Product', type: 'name' },
  { label: 'Cost', type: 'currentPrice' },
]